import { useMemo } from "react";
import { SubscriberEntryPoint, SubscriptionType, UpsellPanelContent } from "../../../constants/upsellPanelEnumsAndConstants";
import useUpsellBaseModel from "./useUpsellBaseModel";

const useFileRequestPopupModel = (fileId, downloadFileUrl) => {
    const baseModel = useUpsellBaseModel();
    const content = {
        ...baseModel.content,
        contentParagraph1: UpsellPanelContent.CREATE_FREE_ACCOUNT,
    };
    const model = useMemo(() => {
        return {
            ...baseModel,
            byPassPhoneVerification: true,
            content,
            displayErrorPanel: false,
            displayQuestionAllSteps: true,
            displayUpsellFooter: false,
            downloadFileId: fileId,
            downloadFileUrl: downloadFileUrl,
            entryPoint: SubscriberEntryPoint.FILE_DOWNLOAD_POPUP,
            hideCloseButton: false,
            hideEmailModal: true,
            hideSignup: true,
            hideSkipPaymentBtn: true,
            mainButtonText: UpsellPanelContent.SIGN_UP_FOR_FREE,
            mobileRequired: false,
            noLoginText: true,
            outerClass: UpsellPanelContent.UPSELL_PANEL_FULL_WIDTH_CSS_CLASS,
            panelClass: UpsellPanelContent.TEXT_WHITE_CSS_CLASS,
            passwordRequired: true,
            productHandle: SubscriptionType.SUBSCRIPTION_INSIGHTS_FREE_PRODUCT_HANDLE,
            secondaryButtonsVertical: false,
            usePopupOverlay: true,
            usePopupOverlayV2: true,
        };
    }, []);

    return model;
};
export default useFileRequestPopupModel;
